export default "__VITE_ASSET__DFb6UMDt__"